@if(taskDataLoaded) {
<div class="overview">
    <h3>Home</h3>
    <div class="content-wrapper">
        @if(needsUrgentContact()) {
        <div class="urgent-contact">
            @if(isNationalityPermitted()) {
            <p>Your application is on hold - <a href="/contact-us/">contact us</a> urgently.</p>
            } @else {
            <p>Unfortunately, owning to US State Department Regulations, we are not able to accept your application due
                to your
                nationality. If you think you have selected the wrong nationality please <a href="/contact-us/">contact
                    us</a>.</p>
            }
        </div>
        } @else {
        <app-system-alert></app-system-alert>
        <app-season-closed></app-season-closed>
        <app-applicant-status></app-applicant-status>
        @if(showEditAvailability) {
        <div class="availability">
            <p>
                Current Availability:
                <strong>{{earliestAvailabilityDate| date:'MMM d' }}{{e0ord}} - {{dateDueHome| date:'MMM d'
                    }}{{e1ord}}</strong>
                <img src="/img/info_icon.png" class="info_icon" alt="Info" (click)="showInfoDialog()" />
            </p>
        </div>
        }
        @if(showPlacementDates) {
        <div class="availability">
            <p>
                Placement Date:
                <strong>{{startDate}}</strong>
                <br>Can't make this date? <a href="#" (click)="showPlacementInfoDialog($event)">Tell us now</a>!
            </p>
        </div>
        }
        @if(unreadCount>0) {
        <div class="unread-messages">
            <strong>
                <p>
                    <span (click)="readMessages()">
                        <span class="fa-regular fa-envelope"></span> {{unreadCountMessage}}
                    </span>
                </p>
            </strong>
        </div>
        }
        @if(showEventButton){
        <div class="event selectable-items-vertical">
            <button type="button" class="btn events-btn" (click)="upcomingEvents()">
                <img src="/img/icons/event_icon.png" class="event-icon"><span
                    [className]="eventClass">{{eventButtonText}}</span>
            </button>
            @if(showSignUpForCDFair) {
            <div class="selectable-item bold-item btn-login btn-focus-shadow" (click)="upcomingEvents()">
                {{registerButtonText}}
            </div>
            }
        </div>
        }
        @if(displayInterviewInfo) {
        <div class="interview-details">
            <h4>Interview Details</h4>
            <app-interview-info [interviewInfo]="interviewInfo" [isHomePage]="true"></app-interview-info>
        </div>
        }

        @if(showNewSeason) {
        @if(applicantAtCamp) {
        <p>
            If you are currently at camp this summer and want to view flights or contact our US office please use
            the menu on the left hand side. You can
            <a href="https://welcome.culturalinsurance.com/college/camp-america-cisi/" target="_blank">find insurance
                information here</a>.
        </p>
        } @else {
        <app-cf-alert class="centre" [type]="AlertType.CallToAction" [heading]="seasonOpenMessage">
            <p class="centre">You’re now ready to apply for the {{season?.seasonNumber}} season - click the button below
                and let’s go to Camp!
            </p>
            @if(showNextSeasonMessage) {
            <p class="next-season centre">
                <a href="https://www.campamerica.co.uk/cad/positions-still-open" target="_blank">
                    Check here to find out which positions we are hiring for before you continue.</a>
            </p>
            }
            <app-cf-button [class.new-season]="true" [type]="ButtonType.NewSeason" [style]="ButtonStyle.Wide"
                (click)="apply()">
                Create your application now!
            </app-cf-button>
        </app-cf-alert>
        }

        }
        @if(showToDoList) {
        <app-todo (itemEdit)="editItem($event)"></app-todo>
        }

        @if(showSubmitApplicationButton) {
        <div class="submit">
            <button type="button" class="btn submit-btn" (click)="submitApplication()">Submit Your Application</button>
        </div>
        }
        }
    </div>
</div>
} @else {
<app-cf-loader>
    <p>Loading... </p>
</app-cf-loader>
}